import firebase from 'firebase'
import 'firebase/firestore'

var config = {
  apiKey: 'AIzaSyBYGroXqzrWUvWOPRFUPnmnhnOQTwG14d4',
  authDomain: 'teamtexting-cvstech.firebaseapp.com',
  databaseURL: 'https://teamtexting-cvstech.firebaseio.com',
  projectId: 'teamtexting-cvstech',
  storageBucket: 'teamtexting-cvstech.appspot.com',
  messagingSenderId: '440344335724'
}
const firebaseApp = firebase.initializeApp(config)

export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/services/firebase.js